export default "__VITE_ASSET__Bfithjyv__"